import Adsense from './AdSense.component';
export default Adsense;